import React from 'react';

import { Group, Switch, Text } from '@mantine/core';
import useUpdateGoogleCalendar from 'hooks/googleCalendar/useUpdateGoogleCalendar';
import { GoogleCalendarAutoComplete } from 'types';
import notificationHandler from 'utils/notifications';

interface ConflictCalendarToggleProps {
  googleCalendar: GoogleCalendarAutoComplete;
  refetchCalendarList: () => void;
}

const ConflictCalendarToggle = ({
  googleCalendar,
  refetchCalendarList,
}: ConflictCalendarToggleProps): JSX.Element => {
  const { errorNotification } = notificationHandler();

  const updateMutation = useUpdateGoogleCalendar({ googleCalendarId: googleCalendar.googleCalendarId });

  const handleToggleConflict = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const isChecked = event.currentTarget.checked;

    updateMutation.mutate(
      {
        googleCalendarId: googleCalendar.googleCalendarId,
        isConflict: isChecked,
      },
      {
        onError: error => {
          errorNotification('Failed to update conflict setting:', error.response?.data.message);
        },
        onSuccess: () => {
          refetchCalendarList();
        },
      },
    );
  };

  return (
    <Group>
      <Switch
        checked={googleCalendar.isConflict}
        onChange={handleToggleConflict}
        disabled={updateMutation.isLoading}
      />
      <Text>{googleCalendar.calendarName}</Text>
    </Group>
  );
};

export default ConflictCalendarToggle;
